import SummarySelection from './selection_summary';

export default SummarySelection;
